export default "__VITE_ASSET__BX48z3ie__"